import React from 'react';
import { HeaderProps } from './types';
import { ReactComponent as BackArrow } from '../../../Assets/JFS/BackArrowWhite.svg';
import styles from './Header.module.css';

const Header: React.FC<HeaderProps> = ({
  title,
  numberOfNudgesLeft,
  currentNudgeIndex,
  onClose,
  showNumberOfNudgesLeft = true,
  showCloseButton = true,
  link,
}) => {
  const totalNudges = currentNudgeIndex + numberOfNudgesLeft;
  const progress =
    totalNudges > 0 ? (currentNudgeIndex / totalNudges) * 100 : 0;

  const size = 32;
  const strokeWidth = 3;
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDashoffset = circumference - (progress / 100) * circumference;
  const titleText = title !== null && title !== '' ? title : '';

  return (
    <div className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.leftSection}>
          {showCloseButton && onClose && (
            <button className={styles.backButton} onClick={onClose}>
              <BackArrow fill='#FFFFFF' />
            </button>
          )}
          <span className={styles.title}>{titleText}</span>
        </div>

        {showNumberOfNudgesLeft && totalNudges > 0 && (
          <div className={styles.rightSection}>
            <div className={styles.progressCircle}>
              <svg width={size} height={size} className={styles.progressSvg}>
                <circle
                  cx={size / 2}
                  cy={size / 2}
                  r={radius}
                  fill='none'
                  stroke='rgba(255, 255, 255, 0.2)'
                  strokeWidth={strokeWidth}
                />
                <circle
                  cx={size / 2}
                  cy={size / 2}
                  r={radius}
                  fill='none'
                  stroke='var(--nudgebutton-color, #ECAD4F)'
                  strokeWidth={strokeWidth}
                  strokeDasharray={circumference}
                  strokeDashoffset={strokeDashoffset}
                  strokeLinecap='round'
                  transform={`rotate(-90 ${size / 2} ${size / 2})`}
                  className={styles.progressPath}
                />
              </svg>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
